<template>

  <div class="padded">

    <h2><i class="fa fa-tachometer-alt" />&nbsp;Workflow Report</h2><br />
    <br />

    <el-tabs type="border-card" stretch>
      <el-tab-pane v-for="(l, i) in list" :key="l.type" :label="l.type">

          <el-row>

            <el-col :span="24">
              <el-table
                   :data="l.data"
                   border
                   size="mini"
                   :row-class-name="tableRowClassName"
                   style="width: 100%">

                   <el-table-column
                        prop="seqNo"
                        :width="70"
                        align="center"
                        label="#">
                   </el-table-column>

                   <el-table-column
                      prop="name"
                      :width="396"
                      label="Type">
                   </el-table-column>

                   <el-table-column
                      prop="stepName"
                      :width="isDesktop ? 396 : 741"
                      label="Step">
                   </el-table-column>

                   <el-table-column
                        prop="status"
                        label="Status">
                   </el-table-column>

                   <el-table-column
                        prop="statusCount"
                        label="# Status"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

                   <el-table-column
                        prop="sites"
                        label="Sites"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

                   <el-table-column
                        prop="grading"
                        label="Grading"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

                   <el-table-column
                        prop="days"
                        label="Days"
                        sortable
                        align="right"
                        :formatter="formatInt">
                   </el-table-column>

              </el-table>

            </el-col>

          </el-row>
        </el-tab-pane>

      </el-tabs>

  </div>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'

export default {
  mixins: [PostMixins, ElTableMixins],


  methods: {

    tableRowClassName ({row, rowIndex}) {
      let cls = 'error-row'

      switch (row.status) {
        case 'Finished':
              cls = 'success-row'
              break

        case 'In Progress':
              cls = 'active-row'
              break

        case 'KIV':
             cls = 'info-row'
            break

        case 'Escalated':
             cls = 'warning-row'
            break

        default:
            cls = 'error-row'
      }

    return cls
    },

    successReport (data) {

      let type = null
      let k = -1

      for (var i = 0; i < data.length; i++) {

        if (data.length > 0 && data[i].type !== type) {
          k += 1
          type = data[i].type
          this.list.push({'type': type, 'data': []})
        }

        this.list[k]['data'].push({'seqNo': data[i].seqNo,
          'category': data[i].category,
          'name': data[i].name,
          'stepName': data[i].stepName,
          'status': data[i].status,
          'statusCount': Number(data[i].statusCount),
          'sites': Number(data[i].sites),
          'grading': Number(data[i].grading),
          'days': Number(data[i].days)})
      }

    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['sites', 'grading'])
    }

  },



  data () {
    return {
      list: []
    }

  },

  created () {
    this.fetchData('/report/workflow/raw', this.successReport, 'Workflow Report')
  }

}

</script>

<style>

.el-table .active-row {
  background: powderblue;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: LightGreen;
}

.el-table .error-row {
  background: LightSalmon;
}

.el-table .info-row {
  background: lightgrey;
}


</style>



// WEBPACK FOOTER //
// WorkflowReport.vue?7affb9ac